import * as React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import ManagementReport from "../management-report"
import Policy from "../policy"
import {
	CUSTOM_TRACKING_PATTERN,
	CUSTOM_TRACKING_MANAGEMENT_REPORT_PATTERN,
	CUSTOM_TRACKING_POLICY_PATTERN
} from "../../util/routes"

export default class CustomTrackingRouter extends React.Component {
	render() {
		return (
			<Switch>
				<Redirect exact from={CUSTOM_TRACKING_PATTERN} to={CUSTOM_TRACKING_MANAGEMENT_REPORT_PATTERN} />
				<Route exact path={CUSTOM_TRACKING_MANAGEMENT_REPORT_PATTERN} component={ManagementReport} />
				<Route exact path={CUSTOM_TRACKING_POLICY_PATTERN} component={Policy} />
			</Switch>
		)
	}
}



// WEBPACK FOOTER //
// ./src/component/router/custom-tracking-router.tsx